import { createContext } from 'react'

export const ReferralContext = createContext<string | undefined>(undefined)
